import React from 'react';

import "./TimeMarkup.scss"

export function markupSeconds(seconds, localizeNumber) {
    const minuteMark = <div style={{ fontSize: "60%" }}>′</div>;
    const secondMark = <div style={{ fontSize: "60%" }}>″</div>;

    const mm = Math.floor(seconds / 60);
    const m = (
        <div className="time-markup-item">
            <div>{localizeNumber(String(mm < 10 ? "0" : "") + String(mm))}</div>
            {minuteMark}
        </div>
    );

    const ss = seconds % 60;
    const s = (
        <div className="time-markup-item">
            <div>{localizeNumber(String(ss < 10 ? "0" : "") + String(ss))}</div>
            {secondMark}
        </div>
    );

    return <div className="time-markup-with-colon" dir="ltr">{m}:{s}</div>
}

// eslint-disable-next-line
function markupMinutes(minutes) {
    const minuteMark = <div style={{ fontSize: "60%" }}>′</div>;

    const hh = Math.floor(minutes / 60);
    const h = (
        <div className="time-markup-item">
            <div>{hh < 10 ? "0" : ""}{hh}</div>
            {minuteMark}
        </div>
    );

    const mm = minutes % 60;
    const m = (
        <div className="time-markup-item">
            <div>{mm < 10 ? "0" : ""}{mm}</div>
            {minuteMark}
        </div>
    );

    return <div className="time-markup-with-colon" dir="ltr">{h}:{m}</div>
}
